class ProductBundling extends HTMLElement {
  constructor() {
    super();
    // console.log("ProductBundling");
    // console.log("ProductBundling");
    this.form = this.querySelector("form");
    this.name = "product-bundling";
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.variantTrigger = this.querySelector("[data-variant-popup-trigger]");
    this.button = this.querySelector(".product-bundling__buttons button");
    this.variantTrigger = this.querySelector("[data-variant-popup-trigger]");
    this.dialog = this.querySelector(".variant-popup-dialog");
    this.init();
  }

  init() {
    if (this.variantTrigger) {
      this.variantTrigger.addEventListener("click", this.handleVariantClick.bind(this));
    }
    if (this.button) {
      this.button.addEventListener("click", this.addToCartWithGift.bind(this));
    }

    if (this.dialog) {
      this.dialog.querySelector(".variant-popup__close").addEventListener("click", () => {
        this.dialog.close();
      });
    }
  }

  handleVariantClick(event) {
    // console.log("handleVariantClick");
    event.preventDefault();
    if (this.dialog) {
      this.dialog.showModal();
    }
  }
  getFormItems() {
    const items = [];
    const triggerSku = this.checkbox.dataset.triggerSku;
    const giftVariantId = this.checkbox.dataset.giftVariantId;
    const giftVariantAId = this.checkbox.dataset.giftVariantAId;
    // console.log(giftVariantAId, "giftVariantAId");
    let shouldAddGift = false;
    let shouldItem = {};
    const checkbox = this.checkbox;
    if (this.checkbox.checked) {
      if (checkbox.checked) {
        const variantId = checkbox.value;
        const quantity = 1;
        const sku = checkbox.dataset.sku;

        items.push({
          id: variantId,
          quantity: 1,
        });

        if (sku === triggerSku) {
          shouldAddGift = true;
          if (shouldItem.quantity) {
            shouldItem.quantity += parseInt(quantity);
          } else {
            shouldItem = {
              id: variantId,
              sku: sku,
              quantity: parseInt(quantity),
            };
          }
        }
      }
    }
    if (giftVariantAId) {
      items.push({
        id: giftVariantAId,
        quantity: 1,
        properties: {
          _is_gift: true,
        },
      });
    }
    if (shouldAddGift && giftVariantId) {
      items.push({
        id: giftVariantId,
        quantity: shouldItem.quantity,
        properties: {
          _is_gift: true,
          _noPrmitEdit: true,
        },
      });
    }

    return items;
  }
  async addToCartWithGift() {
    const newBotton = this.querySelector(".product-bundling__buttons button");
    // console.log(newBotton.getAttribute("aria-bus"), this);
    if (newBotton.getAttribute("aria-bus")) {
      return;
    }
    this.button.style.pointerEvents = "none";
    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );
    let sections = sectionsToBundle.join(",");

    let items = await this.getFormItems();

    let discountCode = this.dataset.discountCode;
    const colortext = this.querySelector(".product-bundling__variant span") || "";
    // console.log(colortext, "colorstext 2");
    if (this.dataset.discountColor && colortext.textContent.includes(this.dataset.discountColor)) {
      discountCode = this.dataset.discountCodeColor;
    }

    if (discountCode) {
      try {
        await fetch("/discount/" + discountCode, {
          method: "GET",
        });
      } catch (error) {
        console.error("折扣码应用失败:", error);
      }
    }

    await this.addItemsToCart(items, sections);
  }

  async addItemsToCart(items, sections) {
    // console.log(items, "addItemsToCart");

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: items,
        sections,
      }),
    });
    if (response.ok) {
      let responseJson = await response.json();
      // console.log(responseJson, "response");
      let cartContent = await this.createCartPromise();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(
        new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson["items"],
            cart: cartContent,
          },
        })
      );
      // // 触发购物车更改事件
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent,
          },
        })
      );
      this.button.removeAttribute("disabled");
      this.button.removeAttribute("aria-busy");
      this.button.style.pointerEvents = "auto";
    } else {
      this.button.removeAttribute("disabled");
      this.button.removeAttribute("aria-busy");
      this.button.style.pointerEvents = "auto";
      throw new Error("Failed to add items to cart");
    }
  }
  async createCartPromise() {
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    return cartContent;
  }
}

customElements.define("product-bundling", ProductBundling);
